// extracted by mini-css-extract-plugin
module.exports = {"symbol":"CategoryPolygon_symbol__3mUQB"};